import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { HeatmapDTO } from '../../model/HeatmapDTO';
import { UniverseDTO } from '../../model/UniverseDTO';
import { Utils } from '../../utils/utils';

@Component({
  selector: 'app-heatmap',
  templateUrl: './heatmap.component.html',
  styleUrls: ['./heatmap.component.css']
})
export class HeatmapComponent implements OnInit {

  @Input() heatmap: HeatmapDTO = null;
  @Input() isLoading = false;
  @Input() isNPS: boolean = false;
  @Input() universe: UniverseDTO;
  @Input() isLoadingUniverse: boolean;

  @ViewChild('table') table: ElementRef;

  constructor() {


  }

  ngOnInit(): void {
  }

  getRows() {
    if (this.heatmap) {
      let rows = [];
      this.heatmap.departments.forEach(dept => {
        let row = [];
        row.push(dept.name);
        this.heatmap.keyDrivers.forEach(key => {
          let value = this.heatmap.values.find(item => {
            return item.departmentID == dept.id && item.keyDriverID == key.id;
          })
          if (value) {
            row.push(value.score);
          }
        })
        rows.push(row);
      });
      return rows;
    }
    return [];
  }

  getKeydrivers() {
    if (this.heatmap) {
      return this.heatmap.keyDrivers;
    }
    return [];
  }

  getColorKeyDriver(value: number): string {
    return Utils.getColorKeyDriver(this.isNPS, value);
  }

  getColorText(value: number) {
    if ((!this.isNPS && value > 0 && value < 5) || (this.isNPS && value <= -50)) {
      return '#FFF';
    }
    return '#3A3A3A';
  }

  getLeyendForKeyDrivers(score: string): string {
    return Utils.getLeyendForKeyDrivers(this.isNPS, score);
  }

  getItemValue(item: number) {
    return this.isNPS ? item : (item == 0 ? '-' : item);
  }

  getTableMarginRight(): string {
    let table = document.getElementById("table");
    if (table) {
      let style = window.getComputedStyle(table);
      return style.marginRight;
    }
    return '0px';
  }

}
